
import RegionService from './RegionService';

export { default } from './RegionService';
export const regionService = new RegionService();